import { render, staticRenderFns } from "./NoValidEvent.vue?vue&type=template&id=801d879a&"
import script from "./NoValidEvent.vue?vue&type=script&lang=js&"
export * from "./NoValidEvent.vue?vue&type=script&lang=js&"
import style0 from "./NoValidEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports